import React from "react"
import Trans from '../../../../../components/Trans'

type VehicleRemarksProps = {
  remarks: string
}

class Remarks extends React.Component<VehicleRemarksProps> {
  render() {
    return (
      <div className="w-full flex flex-col mt-6 md:mt-0">
        <span className='font-semibold text-lg text-gray-700 w-full'><Trans>Öffentliche Bemerkung</Trans></span>

        <pre className="font-sans h-full w-full whitespace-pre-wrap leading-tight">
          {this.props.remarks}
        </pre>
      </div>
    )
  }
}

export default Remarks
